export const closedStorageKey = 'closedWorkflowVersionHistoryPromotion';
